// extracted by mini-css-extract-plugin
module.exports = {"page":"PrivacyPolicy_page__1DZWI","privacy":"PrivacyPolicy_privacy__2-wIQ","cookies":"PrivacyPolicy_cookies__1UNeE"};